﻿import $ from "jquery";
import { Modal, Carousel } from "bootstrap";
import { showMessage } from "./main";

// inicializácia po načítaní DOMu
$(() => {

    var currentPage = $("#currentPage").val();
    if (currentPage != "home") return;

    initFactsSlider();
    initTechSlider();
    
    // =========================
    // MATERIALS (existing)
    // =========================
    const $materials = $("#materials");
    const $items = $materials.find(".home-material-item");
    const $list = $materials.find(".home-material-list");
    const $wrap = $materials.find(".home-materials-wrap");
    const $preview = $materials.find("#materialPreview");
    const $img = $materials.find("#materialPreviewImage");
    const $btn = $materials.find("#materialPreviewButton");

    function isDesktop() {
        return window.matchMedia("(min-width: 992px)").matches;
    }

    function clamp(value: number, min: number, max: number) {
        return Math.max(min, Math.min(max, value));
    }

    function positionPreviewToItem($item: JQuery<HTMLElement>) {
        if (!isDesktop()) return;

        const wrapTop = $wrap.offset()!.top;
        const wrapHeight = $wrap.outerHeight() || 0;

        const itemTop = $item.offset()!.top;
        const itemHeight = $item.outerHeight() || 0;

        const previewHeight = $preview.outerHeight() || 0;

        let top = (itemTop - wrapTop) + (itemHeight / 2) - (previewHeight / 2);
        top = clamp(top, 0, Math.max(0, wrapHeight - previewHeight));

        $preview.css("top", `${top}px`);
    }

    function applyPreviewFromItem($it: JQuery<HTMLElement>) {
        const img = $it.data("img");
        const url = $it.data("url");
        const id = $it.data("id");
        const desc = $it.data("description");

        if (img) $img.attr("src", img);
        $btn.attr("href", "#");   
        //if (url) $btn.attr("href", url);
        if (id) $btn.data('id', id);
        if (url) $btn.data('url', url);

        console.log("Material ID for preview:", id);

        $items.removeClass("active");
        $it.addClass("active");

        $list.addClass("is-hovering");
        positionPreviewToItem($it);

        const $desc = $("#materialPreviewDescription");
        if ($desc.length) $desc.text(desc || "");
    }

    /* DESKTOP: hover -> preview */
    $items.on("mouseenter", function () {
        if (!isDesktop()) return;
        applyPreviewFromItem($(this));
    });

    $items.on("mouseleave", function () {
        if (!isDesktop()) return;
        $list.removeClass("is-hovering");
    });

    /* Keyboard accessibility: Enter/Space otvorí detail (na mobile aj desktope je to OK) */
    $items.on("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;

        const url = String($(this).data("url") || "");
        if (!url) return;

        e.preventDefault();
        window.location.href = url;
    });

    /* INIT: pri načítaní nastav prvý item ako preview (iba desktop) */
    const $first = $items.first();
    if ($first.length && isDesktop()) {
        applyPreviewFromItem($first);
        $list.removeClass("is-hovering"); // nech nie je ztlmenie hneď po load
    }

    /* resize: dorovnaj pozíciu preview podľa active (desktop) */
    $(window).on("resize", function () {
        if (!isDesktop()) return;
        const $active = $items.filter(".active").first();
        if ($active.length) positionPreviewToItem($active);
    });


});


function initTechSlider(): void {
    const $slider = $(".tech-slider");
    if ($slider.length === 0) return;

    const $wrapper = $slider.find(".tech-scroll-wrapper");
    if ($wrapper.length === 0) return;

    const $cards = $wrapper.find(".home-tech-card");
    if ($cards.length === 0) return;

    const cardWidth = $cards.first().outerWidth(true) ?? 0;
    const scrollStep = cardWidth * 1.02;

    const $leftArrow = $slider.find(".tech-arrow-left");
    const $rightArrow = $slider.find(".tech-arrow-right");

    function scrollByStep(direction: number): void {
        const el = $wrapper.get(0) as HTMLElement | undefined;
        if (!el) return;

        const current = el.scrollLeft;
        const maxScroll = el.scrollWidth - el.clientWidth;

        let target = current + direction * scrollStep;
        if (target < 0) target = 0;
        if (target > maxScroll) target = maxScroll;

        el.scrollTo({ left: target, behavior: "smooth" });
    }

    $leftArrow.on("click", (e) => { e.preventDefault(); e.stopPropagation(); scrollByStep(-1); });
    $rightArrow.on("click", (e) => { e.preventDefault(); e.stopPropagation(); scrollByStep(1); });
}


function initFactsSlider(): void {
    const $slider = $(".facts-slider");
    if ($slider.length === 0) return;

    const $wrapper = $slider.find(".facts-scroll-wrapper");
    if ($wrapper.length === 0) return;

    const $inner = $wrapper.find(".facts-inner").first();
    const $blocks = $inner.find(".fact-block");
    if ($blocks.length === 0) return;

    const blockWidth = $blocks.first().outerWidth(true) ?? 0;
    const scrollStep = blockWidth * 1.02;

    const $leftZone = $slider.find(".facts-click-zone-left");
    const $rightZone = $slider.find(".facts-click-zone-right");

    const $leftArrow = $slider.find(".facts-arrow-left");
    const $rightArrow = $slider.find(".facts-arrow-right");

    function scrollByStep(direction: number): void {
        const el = $wrapper.get(0) as HTMLElement | undefined;
        if (!el) return;

        const current = el.scrollLeft;
        const maxScroll = el.scrollWidth - el.clientWidth;

        let target = current + direction * scrollStep;
        if (target < 0) target = 0;
        if (target > maxScroll) target = maxScroll;

        el.scrollTo({
            left: target,
            behavior: "smooth"
        });
    }

    if ($leftZone.length) {
        $leftZone.on("click", (e) => {
            e.preventDefault();
            scrollByStep(-1);
        });
    }

    if ($rightZone.length) {
        $rightZone.on("click", (e) => {
            e.preventDefault();
            scrollByStep(1);
        });
    }

    if ($leftArrow.length) {
        $leftArrow.on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            scrollByStep(-1);
        });
    }

    if ($rightArrow.length) {
        $rightArrow.on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            scrollByStep(1);
        });
    }
}

export { initFactsSlider };
